module.exports = __webpack_public_path__ + "resources/img/readimg@3x.b13f3ec8.png";